import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "../../store/CartContext";
import { useAccount } from "../../store/AccountContext";

export default function BuyAgain({ order }) {
  const { api } = useAccount();
  const { add } = useCart();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(`/orders/${order.id}/reorder`);
      const ok = data.items.filter((i) => i.available);
      const missing = data.items.filter((i) => !i.available);
      if (!ok.length) { toast.error("These items are out of stock right now"); return; }
      ok.forEach((i) => add(i.product, i.variant, i.qty, false));
      if (missing.length) toast.warning(`Skipped (out of stock): ${missing.map((m) => m.name).join(", ")}`);
      navigate("/checkout");
    } catch { toast.error("Could not reorder, please try again"); } finally { setBusy(false); }
  };

  return (
    <button onClick={go} disabled={busy} data-testid={`buy-again-${order.order_number}`} className="inline-flex items-center gap-2 rounded-full bg-[#FC5106] px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-[#E24804] disabled:opacity-60">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <RotateCcw className="h-4 w-4" />} Buy again
    </button>
  );
}
